module.exports = __webpack_public_path__ + "media/WR Blob 10.86ad749a.mp3";